'use client'

import ProductCard from "../product/ProductCard"
import { useEffect, useState } from "react"
import Skeleton from "@/components/elements/Skeleton"
import EmptyState from "@/components/elements/EmptyState"
import { HeartOff } from 'lucide-react'

export default function Wishlist({ wishlist, vendor }: { wishlist: any, vendor: any }) {
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (wishlist !== undefined && wishlist !== null) {
      setIsLoading(false)
    }
  }, [wishlist])

  if (isLoading) {
    return <WishlistSkeleton />
  }

  return (
    <div className="cont py-4 sm:py-8">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-col gap-1">
          <div className="font-semibold text-lg text-foreground">Хүслийн жагсаалт</div>
          <div className="text-sm text-muted-foreground">Таны хүслийн жагсаалтад нэмсэн бүтээгдэхүүнүүд</div>
        </div>
        {wishlist && wishlist.products.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-10">
            {wishlist.products.map((product: any, index: number) => {
              const uniqueKey = `${product.id}-${product.variant?.id || `wishlist-${index}`}`
              return <ProductCard key={uniqueKey} product={product} vendor={vendor} showVariantName />
            })}
          </div>
        ) : (
          <EmptyState icon={HeartOff} title="Хүслийн жагсаалт хоосон байна" description="Таны жагсаалтад нэмсэн бараа энд харагдах болно." />
        )}
      </div>
    </div>
  )
}

function WishlistSkeleton() {
  return (
    <div className="cont py-8">
      <div className="flex flex-col gap-y-6">
        <div className="flex flex-col gap-1">
          <Skeleton className="w-40 h-7" />
          <Skeleton className="w-72 h-5" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-10 mt-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-2">
              <Skeleton className="w-full aspect-square" />
              <Skeleton className="w-3/4 h-4" />
              <Skeleton className="w-3/4 h-4" />
              <Skeleton className="w-1/2 h-4" />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
